import { EnrolleeStatusDisplayName } from "pmt-types/src/enums/EnrolleeStatus.ts";
import { Enrollee } from "pmt-types/src/models/Enrollee.ts";
import { Project } from "pmt-types/src/models/Project.ts";
import { Source } from "pmt-types/src/models/Source.ts";
import { Link } from "react-router-dom";

type Props = {
  source: Source;
  project: Project;
  enrollee: Enrollee;
  onEdit: () => void;
  onDelete: () => void;
};

export default function EnrolleeDetailsCard({
  source,
  project,
  enrollee,
  onEdit,
  onDelete,
}: Props) {
  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-lg ring-1 ring-black ring-opacity-5">
      <div className="px-4 py-4 sm:px-6 bg-gray-50 flex justify-between items-center">
        <h2 className="text-base font-semibold leading-7 text-gray-900">
          {enrollee.name}
        </h2>
        <div className="flex flex-row gap-4">
          <button
            type="button"
            className="relative inline-flex items-center rounded-md bg-sky-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
            onClick={onEdit}
          >
            Edit
          </button>
          <button
            type="button"
            className="relative inline-flex items-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
            onClick={onDelete}
          >
            Delete
          </button>
        </div>
      </div>
      <div className="border-t border-gray-100 px-6">
        <dl className="grid grid-cols-1 sm:grid-cols-2">
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Source
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
              <Link
                className="text-sm font-medium text-sky-500 hover:text-sky-700"
                to={`/sources/${source.id}/details`}
              >
                {source.name}
              </Link>
            </dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Project
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
              <Link
                className="text-sm font-medium text-sky-500 hover:text-sky-700"
                to={`/sources/${source.id}/projects/${project.id}/details`}
              >
                {project.name}
              </Link>
            </dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Status
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
              {EnrolleeStatusDisplayName[enrollee.status]}
            </dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Type of Work
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
              {enrollee.typeOfWork}
            </dd>
          </div>
          <div className="border-t border-gray-100 px-4 py-6 sm:col-span-2 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Notes
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:mt-2">
              {enrollee.notes}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
}
